var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-row',[_c('a-col',{attrs:{"span":"10"}},[_c('a',{on:{"click":_vm.handleGoBack}},[_vm._v("返回")])]),_c('a-col',{attrs:{"span":"8"}})],1),_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }